/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol/Changelog/SingleChangelog";
export const meta = {
  id: 65,
  image: "default-changelog-v2.png",
  title: "GPU Marketplace, Fizz UI Revamp, and Protocol Enhancements",
  shortDescription: "Introducing GPU Marketplace, an upgraded Fizz App UI with analytics and performance boosts, and significant protocol improvements for better deployments and resource management.",
  description: "Introducing GPU Marketplace, an upgraded Fizz App UI with analytics and performance boosts, and significant protocol improvements for better deployments and resource management.",
  date: "November 29th, 2024",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Compute", "Protocol", "Fizz Node", "Gateway", "Spheron Light Node", "CLI", "ICL", "Provider", "Smart Contract", "L3 chain", "Ethereum", "Testnet", "updates"]
};
export const content = `
**GPU Marketplace**
-------------------

Introducing the **GPU Marketplace**, a new way to lease high-performance GPUs for your needs:

*   Navigate to the **Marketplace** tab via the top navigation bar in the Console App.
    
*   Browse a list of GPUs such as **H100** and **RTX4090**, available in multiple quantities (**2x, 4x, 8x**). Each GPU entry displays:
    
    *   GPU Name
        
    *   Quantity
        
    *   Region
        
    *   Price per GPU per hour
        
*   Filter options available to customize your search.
    
*   Select your preferred **template** (e.g., Jupyter, Ollama) and lease **duration** based on your requirements.
    
*   View the **total lease amount**, your **wallet balance**, and confirm the order.
    
*   Lease creation is seamless — within a minute, you’ll be redirected to the **Lease Details** page to:
    
    *   Check deployed services
        
    *   View logs
        
    *   Access port mapping and connection URLs
        

**Updated Fizz App UI**
-----------------------

We’ve overhauled the **Fizz App** UI to provide better analytics and usability:

**Analytics Dashboard:**

*   Visualize key metrics on the homepage:
    
    *   Total **GPU, MAC chips, CPU, RAM, and storage**
        
    *   Total **unique regions**
        
*   Track **node growth** and **FN points** over time via a line graph.
    
*   Explore the new **Fizz Network Map** that shows the distribution of Fizz nodes across regions.
    

**Leaderboard Performance Optimizations:**

*   Faster loading times for the leaderboard.
    
*   Real-time updates every 30 minutes to ensure the latest information is displayed.
    

**New Features:**

*   **Bandwidth Meter UI** to monitor Fizz bandwidth usage.
    
*   **Resource Utilization Table** showing total, utilized, and claimed GPU, CPU, RAM, and storage.
    
*   **Recommended Gateway Highlight**:
    
    *   Automatically suggests a gateway based on proximity.
        
    *   Restricts gateways with more than **1,000 Fizz nodes** during registration or updates.
        

**Protocol Improvements**
-------------------------

**New Functionalities:**

*   **Fizz Slark**:
    
    *   Introduced slashing of rewards for Fizz nodes with **uptime < 50%** or running a version earlier than **v1.1.2**.
        
*   **Lease Logs Streaming**:
    
    *   Enhanced to handle newline and return characters. Logs now update the same line instead of duplicating entries.
        
*   **Autoupgrade** for Fizz nodes, so manual upgrades are needed only for major releases.
    

**Independent Gateway Setup:**

*   Gateway can now run independently without requiring a provider. Setup using CLI commands is supported.
    

**Dashboard Additions:**

*   Fizz dashboards now include:
    
    *   Architecture (**amd64**, etc.)
        
    *   CUDA version
        
    *   NVIDIA driver version
        

**New ICL Attributes:**

*   **desired\_fizz** and **desired\_provider**: Specify deployments on particular Fizz nodes or providers. Detailed Guide available [here](https://docs.spheron.network/user-guide/icl#available-attributes "https://docs.spheron.network/user-guide/icl#available-attributes").
    
*   **Region attribute** is now optional, allowing matchmaking across any region.
    

**Matchmaking Enhancements:**

*   Fizz token consideration in matchmaking when deployment mode is **Fizz**, replacing provider-accepted tokens.
    

**Deployment Capabilities:**

*   \`use_public_port: true\`: Use tunnel ports for public exposure (e.g., for Ray clusters or head nodes). This feature is only available in Fizz deployments.
    
*   Expanded support for **pull\_policy** and **credentials** in the Console App.
`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
